export const messages = {
  en: {
    menu: {
      search: {
        title: 'Search Condition',
        name: 'name',
        gId: 'gId',
        url: 'url',
        seq: 'seq',
        description: 'description',
        isShow: 'isShow',
        createTime: 'createTime',
        placeholder: 'Please enter menu name'
      },
      list: {
        title: 'menu List'
      },
      dialog: {
        addTitle: 'Add Menu',
        editTitle: 'Edit Menu',
        delTitle: 'Delete Menu',
        cancel: 'Cancel',
        confirm: 'Confirm'
      },
      form: {
        mId: 'mId',
        name: 'name',
        gId: 'gId',
        url: 'url',
        seq: 'seq',
        description: 'description',
        isShow: 'isShow',
        createTime: 'createTime',
      },
      table: {
        mId: 'mId',
        name: 'name',
        gId: 'gId',
        url: 'url',
        seq: 'seq',
        description: 'description',
        isShow: 'isShow',
        createTime: 'createTime',
      },
      validate: {
        mId: 'Please enter mId',
        name: 'Please enter name',
        gId: 'Please enter gId',
        url: 'Please enter url',
        seq: 'Please enter seq',
        isShow: 'Please enter isShow',
        createTime: 'Please enter createTime',
      },
      add: {
        success: 'Add Menu success'
      },
      edit: {
        success: 'Edit Menu success'
      },
      delete: {
        success: 'Delete Menu success',
        confirm: 'Are you sure to delete this menu?'
      },
      fetchError: 'Failed to fetch menu list',
      privilege:'privilege'
    }
  },
  zh: {
    menu: {
      search: {
        title: '查询条件',
        name: '菜单名称',
        gId: '菜单组',
        url: '菜单地址',
        seq: '顺序',
        description: '菜单描述',
        isShow: '菜单显示',
        createTime: '创建时间',
        placeholder: '请输入菜单名称'
      },
      list: {
        title: '菜单列表'
      },
      dialog: {
        addTitle: '添加菜单',
        editTitle: '编辑菜单',
        delTitle: '删除菜单',
        cancel: '取消',
        confirm: '确定'
      },
      form: {
        mId: '菜单ID',
        name: '菜单名称',
        gId: '菜单组',
        url: '菜单地址',
        seq: '顺序',
        description: '菜单描述',
        isShow: '菜单显示',
        createTime: '创建时间',
      },
      table: {
        mId: '菜单ID',
        name: '菜单名称',
        gId: '菜单组',
        url: '菜单地址',
        seq: '顺序',
        description: '菜单描述',
        isShow: '菜单显示',
        createTime: '创建时间',
      },
      validate: {
        mId: '请输入菜单ID',
        name: '请输入菜单名称',
        gId: '请输入菜单组',
        url: '请输入菜单地址',
        seq: '请输入顺序',
        isShow: '请输入菜单显示',
        createTime: '请输入创建时间',
      },
      add: {
        success: '添加菜单成功'
      },
      edit: {
        success: '编辑菜单成功'
      },
      delete: {
        success: '删除菜单成功',
        confirm: '确认删除该菜单吗？'
      },
      fetchError: '获取菜单列表失败',
      privilege:'权限'
    }
  }
}